import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SparePartsVehicleCard from "../../components/cards/SparePartsVehicleCard/SparePartsVehicleCard";
import vehiclesData from "../../data/vehiclesData";
import './SparePartsPage.css'
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";

export default function SparePartsPage() {

    const vehiclesWithSpareParts = vehiclesData.filter(
        (vehicle) => vehicle.spareParts && vehicle.spareParts.length > 0
    );

    return (
        <div className="Page">
            <div className="sparePartsPageBanner text-center">
                <div className="page-banner-content">
                    <h3>
                        Premium Strength
                    </h3>
                    <h1>
                        Not Premium Price
                    </h1>
                </div>
            </div>

            <Container fluid>
                <div className="section-spacing">
                    <p class="brand-section-desc text-center mb-0">Genuine LANDKING parts engineered for performance, priced to leave competitors behind.</p>
                </div>

                <Row className="gy-4">
                    {vehiclesWithSpareParts.map((vehicle) => (
                        <Col key={vehicle.id} xs={12} md={6} lg={4}>
                            <SparePartsVehicleCard vehicle={vehicle} />
                        </Col>
                    ))}
                </Row>
            </Container>

            <div className="section-spacing-top">
                <AftersalesSupportSection />
            </div>
        </div>
    );
}